import { axios } from "@/lib/axios";

/** お知らせ */
interface Information {
  id: number;
  /** お知らせタイトル */
  title: string;
  /** お知らせ内容 */
  details: string;
  /** DRM表示フラグ */
  display_drmdx: boolean;
  /** マイページ表示フラグ */
  display_mypage: boolean;
  /** 表示開始日 */
  start_date: string;
  /** 表示終了日 */
  end_date: string;
  /** 最終更新日時 */
  modified: string;
  /** 最終更新者 */
  modified_by: string;
}

/**
 * ログイン画面表示用のお知らせ
 */
export interface LoginInformation {
  information_list: Pick<Information, "id" | "title" | "details">[];
}

/**
 * ログイン画面表示用のお知らせ取得
 */
export const getLoginInformation = () => {
  return axios.get<LoginInformation>(
    "/api/v1/Information/getLoginInformationList",
    { params: { mypage: 1 } }
  );
};
